import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid } from '@mui/material';
import Controls from "./controls/Controls";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';


export default function AdditionalServicesDialog({ open, handleClose, formData, setFormData, handleFormSubmit, serviceType, enabled }) {
  const [formElements, setFormElements] = useState([]);

  const handleRemoveLastElement = () => {
    setFormElements((prevElements) => {
      const updatedElements = prevElements.slice(0, -1);
      setFormData({ ...formData, additionalServices: updatedElements });
      return updatedElements;
    });
  };

  const handleAddElement = () => {
    setFormElements((prevElements) => [...prevElements, { serviceTypeId: null, quantity: '', serviceDetails: '' }]);
  };

  useEffect(() => {
    if (formData && formData.additionalServices && formData.additionalServices.length > 0) {
      setFormElements(formData.additionalServices);
    } else {
      setFormElements([]);
    }
  }, [formData]);

  const isNumber = (value) => {
    const reg = /^[0-9]+$/;
    return reg.test(value);
  };

  const handleElementChange = (event, index) => {
    const { name, value } = event.target;
    if (name === "quantity" && !isNumber(value) && value !== "") {
      return; // Don't update the state if value is not a number and it's not empty
    }
    setFormElements((prevElements) => {
      const updatedElements = [...prevElements];
      updatedElements[index] = {
        ...updatedElements[index],
        [name]: value
      };
      setFormData({ ...formData, additionalServices: updatedElements });
      return updatedElements;
    });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        {enabled ? (
          <DialogTitle id="alert-dialog-title">Dodaj usługę</DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title">Podgląd</DialogTitle>
        )}
        <Divider />
        <DialogContent>
          <form>
            {formElements && formElements.length > 0 ? (
              formElements.map((element, index) => (
                <Grid
                  key={index}
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 4 }}
                >
                  <Grid item xs={9}>
                    <Controls.Select
                      name="serviceTypeId"
                      label="Nazwa usługi"
                      value={element.serviceTypeId || null}
                      onChange={(e) => handleElementChange(e, index)}
                      options={serviceType}
                      disabled={!enabled}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Controls.Input
                      name="quantity"
                      value={String(element.quantity) || ''}
                      onChange={(e) => handleElementChange(e, index)}
                      placeholder="Podaj liczbę"
                      label="Liczba"
                      disabled={!enabled}
                    />
                  </Grid>
                  {element.serviceTypeId === 41 && (
                    <Grid item xs={12}>
                      <Controls.Input
                        name="serviceDetails"
                        value={String(element.serviceDetails) || ''}
                        onChange={(e) => handleElementChange(e, index)}
                        placeholder="Opisz usługę"
                        label="Opis usługi"
                        disabled={!enabled}
                      />
                    </Grid>
                  )}
                </Grid>
              ))
            ) : (
              <p style={{fontSize: 18}}>Brak elementów...</p>
            )}
            <Box sx={{ m: '15px' }} />
            <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={6}>
                {formElements?.length > 0 && enabled && ( // <-- Add enabled check here
                  <Button variant="contained" onClick={handleRemoveLastElement}>
                    Usuń ostatnią
                  </Button>
                )}
              </Grid>
              <Grid item xs={6}>
                {enabled && ( // <-- Add enabled check here
                  <Button style={{ float: 'right' }} variant="contained" color="secondary" onClick={handleAddElement}>
                    Dodaj usługę
                  </Button>
                )}
              </Grid>
              <Box sx={{ m: '10px' }} />
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          {enabled ? (
            <>
              <Button onClick={handleClose} color="secondary" variant="outlined">
                Anuluj
              </Button>
              <Button color="primary" onClick={handleFormSubmit} variant="contained">
                Zapisz
              </Button>
            </>
          ) : (
            <Button onClick={handleClose} color="primary" variant="contained">
              Zamnij
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}